export enum AccomodationSpecials {
  FACILITY = 'ACCOMMODATION_FACILITY',
  ACTIVITY = 'ACCOMMODATION_ACTIVITY',
  LANGUAGE = 'GENERIC_LANGUAGES',
  POSITION = 'ACCOMMODATION_POSITION'
}
